import { IContent } from 'json-as-xlsx';
import { OOCFrameOccupancy, OOCReportCampaignDetails } from 'components/common/types/DirectSalesCampaign.types';

export const getTableContent = (campaignDetails: OOCReportCampaignDetails[]): IContent[] => {
  return campaignDetails.reduce(
    (
      acc: IContent[],
      {
        campaignId,
        userVisibleId,
        salesTeam,
        salesPerson,
        adminPerson,
        brand,
        status,
        campaignStartDate,
        campaignEndDate,
        frameOccupancies,
        frameDetails,
      },
    ) => {
      const weeksData: Record<string, number> = {};

      frameOccupancies.forEach((occupancy: OOCFrameOccupancy) => {
        if (!occupancy.occupancyWeek.weekStartDate) {
          return;
        }

        const [year] = occupancy.occupancyWeek.weekStartDate.split('-');
        weeksData[`${occupancy.occupancyWeek.week}${year}`] = occupancy.frameCount;
      });

      frameDetails.forEach(
        ({
          frameId,
          businessArea,
          routeFrameCode,
          sizeCode,
          furnitureId,
          productFormat,
          mediaType,
          routeTown,
          address,
        }) => {
          acc.push({
            campaignId,
            userVisibleId: userVisibleId ?? '',
            salesTeam,
            salesPerson,
            adminPerson,
            brand,
            status,
            campaignStartDate,
            campaignEndDate,
            frameId,
            businessArea,
            routeFrameCode,
            sizeCode,
            furnitureId,
            productFormat,
            mediaType,
            routeTown,
            address,
            ...weeksData,
          });
        },
      );
      return acc;
    },
    [],
  );
};
